document.addEventListener('DOMContentLoaded', () => {
    const KEY_AUTH = 'lk_auth_state';
    const HIDE_BLOCK_CLASSNAME = 'hidden';

    const buttonLoyaltyNoAuthElement = document.querySelector('.loyalty-main__button--no-auth');
    const buttonLoyaltyAuthElement = document.querySelector('.loyalty-main__button--auth');

    if (!buttonLoyaltyNoAuthElement || !buttonLoyaltyAuthElement) return;

    function updateVisibilityButtons(isAuth) {
        const authorized = isAuth === true;

        buttonLoyaltyAuthElement.classList.toggle(HIDE_BLOCK_CLASSNAME, !authorized);
        buttonLoyaltyNoAuthElement.classList.toggle(HIDE_BLOCK_CLASSNAME, authorized);
    }

    const authData = JSON.parse(localStorage.getItem(KEY_AUTH));
    const currentStateAuth = authData?.isAuthorized ?? false;
    updateVisibilityButtons(currentStateAuth);

    if (typeof BroadcastChannel !== 'undefined') {
        const authChannel = new BroadcastChannel('lk_auth');
        authChannel.addEventListener('message', function (evt) {
            if (evt.data && evt.data.type === 'AUTH_UPDATE') {
                updateVisibilityButtons(evt.data.isAuthorized);
            }
        });
        window.addEventListener('beforeunload', function () {
            authChannel.close();
        });
    }
});